import { window } from '../window';
import { MixpanelRecorder } from './recorder';

window['__mp_recorder'] = MixpanelRecorder;
